module.exports = __webpack_public_path__ + "img/xp-7515.a8819015.png";